export default function AdminRoutes() {
  return [
    {
      path: '',
      redirect: { name: 'adminAccount' }
    },
    {
      path: 'account',
      component: () => import(/* webpackChunkName: "accessSummary" */ './AdminAccount.vue'),
      name: 'adminAccount',
      meta: {
        title: 'Admin - Account'
      }
    },
    {
      path: 'users',
      component: () => import(/* webpackChunkName: "accessSummary" */ './AdminUserManagement.vue'),
      name: 'adminUserManagement',
      meta: {
        title: 'Admin - Users'
      }
    },
    {
      path: 'software',
      component: () => import(/* webpackChunkName: "accessSummary" */ './AdminSoftware.vue'),
      name: 'adminSoftware',
      meta: {
        title: 'Admin - Software'
      }
    },
    {
      path: 'network',
      component: () => import(/* webpackChunkName: "accessSummary" */ './AdminNetwork.vue'),
      name: 'adminNetwork',
      meta: {
        title: 'Admin - Network'
      }
    }
  ]
}
